import {
    FETCH_FEATURE_FLAGS_DATA,
    FETCH_FEATURE_FLAGS_DATA_SUCCESS,
    FETCH_FEATURE_FLAGS_DATA_FAILURE,
} from "../actions/featureFlags/types";

const initialState = {
    loading: false,
    error: {},
    featureFlagsData: []
};

export default function featureFlagsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_FEATURE_FLAGS_DATA:
            return { ...state, loading: action.isLoading };
        case FETCH_FEATURE_FLAGS_DATA_SUCCESS:
            return { featureFlagsData: action.data, loading: action.isLoading };
        case FETCH_FEATURE_FLAGS_DATA_FAILURE:
            return { ...state, error: action.error, loading: action.isLoading };
        default:
            return state;
    }
}